import { BoundaryPosition } from "../../../context/root/types";

export const US_CENTER_POINT = [39.5, -98.35]
export const DEFAULT_ZOOM = 5;
export const MIN_ZOOM = 3;
export const MAX_ZOOM = 12
export const DEFAULT_BOUNDARIES_POSITIONS = {
  northEast: {
    lat: 52.696361078274485,
    lng: -53.349609375
  },
  northWest: {
    lat: 52.696361078274485,
    lng: -137.724609375
  },
  southEast: {
    lat: 23.200960808078566,
    lng: -53.349609375
  },
  southWest: {
    lat: 23.200960808078566,
    lng: -137.724609375
  },
  type: "screen"
} as {
  northEast: BoundaryPosition;
  northWest: BoundaryPosition;
  southEast: BoundaryPosition;
  southWest: BoundaryPosition;
  type: "bucket" | "screen"
}

export const getMapBoundries = (mapObject: any) => {
  const mapBounds = mapObject.getBounds();
  const northEast = mapBounds.getNorthEast();
  const northWest = mapBounds.getNorthWest();
  const southEast = mapBounds.getSouthEast();
  const southWest = mapBounds.getSouthWest();
  return {
    northEast: { lat: northEast.lat, lng: northEast.lng },
    northWest: { lat: northWest.lat, lng: northWest.lng },
    southEast: { lat: southEast.lat, lng: southEast.lng },
    southWest: { lat: southWest.lat, lng: southWest.lng }
  }
}
